export function scsSliders(){
    jQuery(function($){
        const sliders = [
            {
                el:$('.home-slider .slider'),
                config:{
                    infinite:true,
                    dots:true,
                    prevArrow:$('.home-slider .slick-prev'),
                    nextArrow:$('.home-slider .slick-next'),
                    autoplay: true,
                    autoplaySpeed: 10000
                }
            },
            {
                el:$('.callout-slider'),
                config:{
                    arrows:false,
                    infinite:true,
                    autoplay:true,
                    autoplaySpeed:6000,
                    fade:true,
                    adaptiveHeight:true,
                    dots:true,
                    swipe:false
                }
            }
        ];

        const lazyLoadBg = function( el ) {
            const lazyEl = $(el).find('.bg-lazy');
            const bg = lazyEl.attr('data-lazy-bg');

            lazyEl.css('background-image','url('+bg+')');
            lazyEl.removeClass('bg-lazy');
        }

        sliders.forEach(slider => {
            if(slider.el.length){
                const s = slider.el.slick(slider.config);
                s.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    if (currentSlide !== nextSlide) {
                        lazyLoadBg($(slick.$slides.get(nextSlide)));
                    }
                });
            }
        });
    });
}